(() => {
'use strict';
function initialize(root) {
 if(root.dataset.obfReady)return;
 root.dataset.obfReady='true';
 const label=(element,selected)=>{element.setAttribute('aria-selected',String(selected));element.tabIndex=selected?0:-1;};
 root.querySelectorAll('[data-obf-tabs]').forEach(tabs=>{
  const section=tabs.closest('[data-obf-group]');
  const buttons=[...tabs.querySelectorAll('[role="tab"]')];
  function select(button) {
   buttons.forEach(b=>label(b,b===button));
   section.querySelectorAll(':scope > [data-obf-panels] > [role="tabpanel"]').forEach(panel=>{panel.hidden=panel.id!==button.getAttribute('aria-controls');});
   section.querySelectorAll('[data-obf-carousel]').forEach(carousel=>carousel.dispatchEvent(new Event('obf:resize')));
  }
  buttons.forEach(b=>b.addEventListener('click',()=>select(b)));
  tabs.addEventListener('keydown',e=>{
   const current=buttons.indexOf(document.activeElement);
   if(current<0||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
   e.preventDefault();
   const next=e.key==='Home'?0:e.key==='End'?buttons.length-1:(current+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
   buttons[next].focus({preventScroll:true});select(buttons[next]);buttons[next].scrollIntoView({block:'nearest',inline:'nearest'});
  });
  if(buttons[0])select(buttons.find(b=>b.getAttribute('aria-selected')==='true')||buttons[0]);
 });
 const controllers=new Map();
 root.querySelectorAll('[data-obf-carousel]').forEach(carousel=>{
  const rail=carousel.querySelector('[data-obf-rail]'),previous=carousel.querySelector('[data-obf-prev]'),next=carousel.querySelector('[data-obf-next]'),status=carousel.querySelector('[data-obf-status]');
  function measure(){
   const items=[...rail.children];
   if(!items.length||!rail.clientWidth)return null;
   const columns=[...new Set(items.map(item=>item.offsetLeft))].sort((a,b)=>a-b);
   const gap=parseFloat(getComputedStyle(rail).columnGap)||0;
   const step=(columns[1]-columns[0])||items[0].getBoundingClientRect().width+gap;
   const rows=items.filter(item=>item.offsetLeft===columns[0]).length;
   const visibleColumns=Math.max(1,Math.floor((rail.clientWidth+gap+1)/Math.max(step,1)));
   const startColumn=Math.min(Math.max(0,columns.length-visibleColumns),Math.max(0,Math.round(rail.scrollLeft/Math.max(step,1))));
   return {items,step,rows,visibleColumns,startColumn};
  }
  function update(){
   const layout=measure();
   if(!layout){if(!rail.children.length){if(status)status.textContent='No designs in this selection';if(previous)previous.disabled=true;if(next)next.disabled=true;}return;}
   const {items,rows,visibleColumns,startColumn}=layout;
   if(status)status.textContent=(startColumn*rows+1)+'–'+Math.min(items.length,(startColumn+visibleColumns)*rows)+' / '+items.length+' designs';
   if(previous)previous.disabled=rail.scrollLeft<=2;
   if(next)next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-3;
  }
  function move(direction){
   const layout=measure();if(!layout)return;
   rail.scrollBy({left:direction*layout.step*layout.visibleColumns,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  previous?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
  rail.addEventListener('scroll',update,{passive:true});
  rail.addEventListener('keydown',e=>{if(e.target!==rail)return;if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();if(e.key==='Home')rail.scrollTo({left:0});else if(e.key==='End')rail.scrollTo({left:rail.scrollWidth});else move(e.key==='ArrowRight'?1:-1);}});
  carousel.addEventListener('obf:resize',update);
  const observer=new ResizeObserver(update);observer.observe(rail);
  controllers.set(carousel,update);update();
 });
 const budget=root.querySelector('[data-obf-budget]');
 if(budget){
  const tabs=budget.querySelector('[data-obf-budget-tabs]'),panel=budget.querySelector('[data-obf-budget-panel]'),rail=panel.querySelector('[data-obf-rail]'),source=budget.querySelector('template[data-obf-budget-source]');
  const all=[...source.content.querySelectorAll('.obf-product')];
  const buttons=[...tabs.querySelectorAll('[role="tab"]')];
  function select(button){
   buttons.forEach(b=>label(b,b===button));panel.setAttribute('aria-labelledby',button.id);
   const matches=all.filter(card=>Number(card.dataset.obfPrice)>=Number(button.dataset.min)&&Number(card.dataset.obfPrice)<Number(button.dataset.max)).sort((a,b)=>Number(a.dataset.obfPrice)-Number(b.dataset.obfPrice)).slice(0,8);
   rail.replaceChildren(...matches.map(card=>card.cloneNode(true)));rail.scrollLeft=0;
   controllers.get(panel.querySelector('[data-obf-carousel]'))?.();
  }
  buttons.forEach(b=>b.addEventListener('click',()=>select(b)));
  tabs.addEventListener('keydown',e=>{const current=buttons.indexOf(document.activeElement);if(current<0||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const n=e.key==='Home'?0:e.key==='End'?buttons.length-1:(current+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;buttons[n].focus({preventScroll:true});select(buttons[n]);});
  select(buttons[0]);
 }
 let timer;
 function toast(text){const el=root.querySelector('[data-obf-toast]');if(!el)return;clearTimeout(timer);el.textContent=text;el.classList.add('is-visible');timer=setTimeout(()=>el.classList.remove('is-visible'),3500);}
 root.querySelectorAll('[data-copy-code]').forEach(button=>button.addEventListener('click',async()=>{
  const code=button.dataset.copyCode,span=button.querySelector('[data-copy-label]');
  try{await navigator.clipboard.writeText(code);if(span)span.textContent='Copied';toast(code+' copied. Enter it at checkout.');setTimeout(()=>{if(span)span.textContent='Copy code';},3000);}
  catch{toast('Your code is '+code+'. Enter it at checkout.');}
 }));
}
function scan(scope){scope.querySelectorAll('[data-orleone-sale]').forEach(initialize);}
scan(document);
document.addEventListener('shopify:section:load',event=>scan(event.target));
})();
